export default __webpack_public_path__ + "static/media/dog8.b5cf5c74.png";